import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Messages Redux States
import { GET_CLIENT_INFO } from "./actionTypes";
import { clientInfoError, setClientInfo } from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* getClientInfo({ payload: chatId }) {
  try {
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_MESSAGES_API_URL}/tech4h-messages/conversation/info?id=${chatId}`,
      {
        headers: { apiVersion: "3" },
      }
    );

    if (response.status === 200) {
      yield put(setClientInfo(chatId, response.data.data));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message = "Get client info error";
    yield put(clientInfoError({ action: "get_info", message: message }));
  }
}

export function* watchGetClientInfo() {
  yield takeEvery(GET_CLIENT_INFO, getClientInfo);
}
function* authSaga() {
  yield all([fork(watchGetClientInfo)]);
}

export default authSaga;
